import { render } from "solid-js/web";
import { Button } from "~/common/button";
import { TwelveEntrypointWrapper } from "~/util/entrypoint";
import { Dialog } from "~/util/html/dialog";

export function confirmLocationSwitch(): {
  promise: Promise<boolean>;
  cleanup: () => void;
} {
  let resolvePromise: (value: boolean) => void;
  let disposed = false;

  const promise = new Promise<boolean>((resolve) => {
    resolvePromise = resolve;
  });

  const container = document.createElement("div");
  document.body.appendChild(container);

  const dispose = render(() => {
    const handleExit = (confirmed: boolean) => {
      if (disposed) return;
      disposed = true;
      resolvePromise(confirmed);
      dispose();
      container.remove();
    };
    return (
      <TwelveEntrypointWrapper
        entry={() => (
          <Dialog
            title="Switch location"
            onEnter={() => handleExit(true)}
            onClose={() => handleExit(false)}
            footerActions={
              <>
                <Button variant="secondary" size="medium" onClick={() => handleExit(false)}>
                  Stay here
                </Button>
                <Button variant="primary" size="medium" onClick={() => handleExit(true)}>
                  Continue
                </Button>
              </>
            }
          >
            <p class="text-sm text-typography-secondary">
              This will switch you to a different location.
            </p>
          </Dialog>
        )}
      />
    );
  }, container);

  const cleanup = () => {
    if (disposed) return;
    disposed = true;
    resolvePromise(false);
    dispose();
    container.remove();
  };

  return { promise, cleanup };
}
